<template>
  <el-button
    :type="type"
    :size="size"
    :icon="CopyIcon"
    @click="handleCopy"
    :loading="copying"
    :title="title"
  >
    <template #icon>
      <svg
        viewBox="0 0 1024 1024"
        width="1em"
        height="1em"
        fill="currentColor"
      >
        <path
          d="M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.4c2 0.3 4.1 0.5 6.1 0.5H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM672 888H414V746c0-22.1-17.9-40-40-40H232V256h440v632z"
        />
      </svg>
    </template>
    <span v-if="showText">{{ text }}</span>
  </el-button>
</template>

<script setup>
import { ref } from 'vue'
import { ElMessage } from 'element-plus'
import { copyToClipboard } from '@/utils/utils'

// 定义 props
const props = defineProps({
  // 要复制的内容
  content: {
    type: String,
    required: true
  },
  // 按钮类型
  type: {
    type: String,
    default: 'default'
  },
  // 按钮大小
  size: {
    type: String,
    default: 'small'
  },
  // 按钮文本
  text: {
    type: String,
    default: '复制'
  },
  // 是否显示文本
  showText: {
    type: Boolean,
    default: true
  },
  // 鼠标悬停提示
  title: {
    type: String,
    default: '点击复制'
  },
  // 成功提示消息
  successMessage: {
    type: String,
    default: '复制成功'
  },
  // 失败提示消息
  errorMessage: {
    type: String,
    default: '复制失败'
  }
})

// 定义 emits
const emit = defineEmits(['copy-success', 'copy-error'])

// 响应式数据
const copying = ref(false)

// 复制处理函数
const handleCopy = async () => {
  if (!props.content) {
    ElMessage.warning('没有可复制的内容')
    return
  }

  copying.value = true
  
  try {
    const result = await copyToClipboard(props.content)
    
    if (result.success) {
      ElMessage.success(props.successMessage)
      emit('copy-success', props.content)
    } else {
      ElMessage.error(props.errorMessage)
      emit('copy-error', result.message)
    }
  } catch (error) {
    ElMessage.error(props.errorMessage)
    emit('copy-error', error.message)
  } finally {
    copying.value = false
  }
}
</script>

<style scoped>
.el-button {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: transparent;
  border: none;
  padding-left: 5px;
}

svg {
  transition: transform 0.2s ease;
}

.el-button:hover svg {
  transform: scale(1.1);
}
</style>